module.exports = __webpack_public_path__ + "img/control4.4f83c960.svg";